import { observer } from 'mobx-react';
import { CloseAction } from './UseOpenable';

interface ModalShadeProps {
  className?: string;
  close: CloseAction;
}

function ModalShade({ className, close }: ModalShadeProps) {
  return <div className={className} onClick={close} data-test-modal-shade={true} />;
}

export default observer(ModalShade);
